/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: 0 },
  { id: 1, value: 0 },
  { id: 2, value: 0 },
  { id: 3, value: 0 },
  { id: 4, value: 0 },
  { id: 5, value: 0 },
  { id: 6, value: 0 },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: value };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}></Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Giá trị gia tăng âm được kết chuyển kỳ trước"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[21]"}
              </Td>

              <Td
                colSpan={2}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={0} name="value" value={data[0].value} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Tổng doanh thu hàng hóa, dịch vụ bán ra"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[22]"}
              </Td>

              <Td
                colSpan={2}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={1} name="value" value={data[1].value} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Giá vốn của hàng hóa, dịch vụ mua vào"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[23]"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={2} name="value" value={data[2].value} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh tăng giá trị gia tăng âm của các kỳ trước"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[24]"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={3} name="value" value={data[3].value} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh giảm giá trị gia tăng âm của các kỳ trước"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                }}
              >
                {"[25]"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable id={4} name="value" value={data[4].value} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Giá trị gia tăng chịu thuế trong kỳ ([26]=[22]-[23]-[21]-[24]+[25])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[26]"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={5}
                  name="value"
                  readonly="true"
                  value={data[5].value}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Thuế giá trị gia tăng phải nộp ([27]=[26] x Thuế suất)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[27]"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={6} name="value" value={data[6].value} onChange={handleChange} />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 20,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontSize: "14px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
